<template>
  <button
    type="button"
    v-bind="$attrs"
    class="
      bg-[#c54d56]
      text-left
      text-white
      text-[12px]
      font-normal
      px-[16px]
      py-[8px]
      rounded-full
      hover:opacity-90
      transition
      cursor-pointer
      focus-visible:outline
      focus-visible:outline-2
      focus-visible:outline-offset-2
      focus-visible:outline-[#191919]
    "
    @click="emit('click', label)"
    data-testid="pdp-pill-button"
  >
    {{ label }}
  </button>
</template>



<script setup lang="ts">
const props = defineProps<{
  label: string
}>()

const emit = defineEmits<{
  (e: 'click', value: string): void
}>()
</script>